export default __webpack_public_path__ + "static/media/Breakout2small.beeab1a7.jpg";